import { AsyncSelect, type SelectOption } from '@percent/lemonade'
import { useEffect, useState } from 'react'
import usePlacesService from 'react-google-autocomplete/lib/usePlacesAutocompleteService'

import { parseAddressFromComponents } from './utils'
import type { AddressLookupProps } from './address-lookup.types'

export function PlacesAutocomplete({
  onSelect,
  googleMapsApiKey,
  language,
  placeholder,
}: Readonly<AddressLookupProps>) {
  const [locationQuery, setLocationQuery] = useState('')
  const {
    isPlacePredictionsLoading,
    placePredictions,
    getPlacePredictions,
    placesService,
  } = usePlacesService({
    apiKey: googleMapsApiKey,
  })

  useEffect(() => {
    if (locationQuery.trim()) {
      getPlacePredictions({
        input: locationQuery,
        language: language,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationQuery, language])

  const handleInput = (query: string) => {
    setLocationQuery(query)
  }

  const handleSelect = (val: SelectOption | null) => {
    if (!val?.value) {
      return
    }

    placesService?.getDetails({ placeId: val.value }, (d) => {
      if (typeof d === 'string' || d === null) {
        return
      }

      onSelect?.({
        ...parseAddressFromComponents(d.address_components),
        lat: d.geometry?.location?.lat(),
        long: d.geometry?.location?.lng(),
      })
    })
  }

  return (
    <AsyncSelect
      options={placePredictions.map((a) => ({
        label: a.description,
        value: a.place_id,
      }))}
      setQuery={handleInput}
      loading={isPlacePredictionsLoading}
      onChange={handleSelect}
      placeholder={placeholder}
      borderRadiiSize="large"
    />
  )
}
